import { Formik, FormikProps } from "formik";
import { observer } from "mobx-react";
import * as React from "react";
import { Button, Form, Table, Modal, Row, Col, Alert } from "react-bootstrap";
import * as yup from 'yup';

interface IProps {
    isOpened: boolean;
    closeModal: () => void;
    createUser: (email: string,
        password: string,
        lastName: string,
        firstName: string,
        middleName: string) => void;
}

interface IState {
    email: string,
    password: string,
    firstName: string,
    lastName: string,
    middleName: string
}

const schema = yup.object({
    email: yup.string().required("Введите email пользователя").email("Email некорректен"),
    password: yup.string().required("Введите пароль пользователя"),
    firstName: yup.string().required("Введите имя пользователя"),
    lastName: yup.string().required("Введите фамилию пользователя"),
    middleName: yup.string().required("Введите отчество пользователя")
});


@observer
export default class AddUserModal extends React.Component<IProps, IState> {
    constructor(props: any) {
        super(props);

        this.state = {
            email: "",
            password: "",
            firstName: "",
            lastName: "",
            middleName: ""
        }
    }



    private onChange(targetName: string, targetValue: string) {
        this.setState((prevState) => ({
            ...prevState,
            [targetName]: targetValue
        }));
    }


    render() {
        return <Modal show={this.props.isOpened} onHide={this.props.closeModal} className="modal-xs" >
            <Modal.Header closeButton>
                <Modal.Title>
                    Добавление пользователя
                </Modal.Title>
            </Modal.Header>

            <Formik
                validationSchema={schema}
                onSubmit={(values, actions) => {
                    this.props.createUser(
                        values.email,
                        values.password,
                        values.lastName,
                        values.firstName,
                        values.middleName
                    )
                }}
                initialValues={this.state}
                render={(props) => (
                    <>
                        <Modal.Body>
                            {this.renderForm(props)}
                        </Modal.Body>
                        <Modal.Footer>
                            <Button variant="secondary" onClick={this.props.closeModal}>Отменить</Button>
                            <Button variant="primary" onClick={props.submitForm}>Создать пользователя</Button>
                        </Modal.Footer>
                    </>
                )} />

        </Modal >
    }

    renderForm = (props: FormikProps<IState>) => {
        return (<Form onSubmit={props.handleSubmit} >
            <Form.Group as={Row} controlId="formEmail">
                <Form.Label column sm="2">Email</Form.Label>
                <Col sm="10">
                    <Form.Control type="text" placeholder="Укажите Email"
                        value={props.values.email}
                        name="email"
                        onChange={props.handleChange}
                        isInvalid={!!props.errors.email}
                    />
                    <Form.Control.Feedback type="invalid">
                        {props.errors.email}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formPassword">
                <Form.Label column sm="2">Пароль</Form.Label>
                <Col sm="10">
                    <Form.Control type="text" placeholder="Укажите пароль"
                        value={props.values.password}
                        name="password"
                        onChange={props.handleChange}
                        isInvalid={!!props.errors.password}
                    />
                    <Form.Control.Feedback type="invalid">
                        {props.errors.password}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formLastName">
                <Form.Label column sm="2">Фамилия</Form.Label>
                <Col sm="10">
                    <Form.Control type="text" placeholder="Укажите фамилию"
                        value={props.values.lastName}
                        name="lastName"
                        onChange={props.handleChange}
                        isInvalid={!!props.errors.lastName}
                    />
                    <Form.Control.Feedback type="invalid">
                        {props.errors.email}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formFirstName">
                <Form.Label column sm="2">Имя</Form.Label>
                <Col sm="10">
                    <Form.Control type="text" placeholder="Укажите имя"
                        value={props.values.firstName}
                        name="firstName"
                        onChange={props.handleChange}
                        isInvalid={!!props.errors.firstName}
                    />
                    <Form.Control.Feedback type="invalid">
                        {props.errors.firstName}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
            <Form.Group as={Row} controlId="formMiddleName">
                <Form.Label column sm="2">Отчество</Form.Label>
                <Col sm="10">
                    <Form.Control type="text" placeholder="Укажите отчество"
                        value={props.values.middleName}
                        name="middleName"
                        onChange={props.handleChange}
                        isInvalid={!!props.errors.middleName}
                    />
                    <Form.Control.Feedback type="invalid">
                        {props.errors.middleName}
                    </Form.Control.Feedback>
                </Col>
            </Form.Group>
        </Form >)
    }
}

